import { render, staticRenderFns } from "./CollectCard.vue?vue&type=template&id=10fe7ad6&scoped=true&"
import script from "./CollectCard.vue?vue&type=script&lang=js&"
export * from "./CollectCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectCard.vue?vue&type=style&index=0&id=10fe7ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe7ad6",
  null
  
)

export default component.exports